<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">

  <p-toolbar>
    <ng-template #start>
      <div class="toolbar-menu">
        <p-selectButton [options]="resultsDisplay" [(ngModel)]="selectedResultDisplay"
          (onChange)="onSelectedResultDisplayUpdated($event)" [allowEmpty]="false">
        </p-selectButton>
      </div>
    </ng-template>

    <ng-template #end>
      @if (!wellheadDisabled && selectedResultDisplay === 'grid') {
        <span class="validation-error pr-2">
          Wellhead Hanger Lockdown Rating: {{ lockdownRating }} {{ forceUnit }}
        </span>
      }
    </ng-template>
  </p-toolbar>

  @if (selectedResultDisplay === 'plot' && !isLoading()) {
    <app-xy-line-plot [plotData]="plot.data"
      [xAxisTitle]="xAxisTitle" [yAxisTitle]="yAxisTitle" [plotName]="plotName" [downloadPlotName]="downloadPlotName"
      [legendBelowPlot]="true" [annotations]="annotations" [shapes]="shapes" [plotTitle]="'Lift-Off Results'"
      [xyLinePlotStore]="liftoffResultsStore">
    </app-xy-line-plot>
  }

  <app-single-load-grid 
    [hidden]="selectedResultDisplay !== 'grid'" 
    [rowData]="results"
    [columnDefinitions]="columnDefinitions"
    tableName="Lift-Off Results" 
    [hangerLiftoffForce]="lockdownRating"
    gridName="Lift-Off Results" 
  ></app-single-load-grid>
  
  <p-dialog [draggable]="false" [visible]="errorMsg != null" [closable]="false" appendTo="self">
    <i class="pi pi-exclamation-circle pr-1"></i>
    <label>{{ errorMsg }}</label>
    <br> <br>
  </p-dialog>
  
  @if (results != null) {
    <app-perivis-validation [errors]="results[0]?.errors" />
  }

</app-tool-loader>